export enum RouteNames {
  About = 'About'
}
